module.exports = __webpack_public_path__ + "static/img/2.4a952ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user/2.png
// module id = SHCf
// module chunks = 0